var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgViewInvoice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "1644 792 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11062",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1660 792c-8.876 0-16 7.18-16 16 0 8.876 7.18 16 16 16s16-7.18 16-16-7.18-16-16-16m0 30.926c-8.198 0-14.87-6.672-14.87-14.87 0-8.197 6.672-14.869 14.87-14.869s14.87 6.672 14.87 14.87c0 8.197-6.672 14.869-14.87 14.869",
  fill: "#26890d",
  "data-name": "Path 280411"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1670.007 807.718c-1.414-2.149-5.089-5.767-10.007-5.767-4.523 0-8.142 2.94-10.007 5.71a.817.817 0 0 0-.113.396c0 .113 0 .226.056.283 1.414 2.148 5.088 5.767 10.007 5.767 4.523 0 8.142-2.94 10.007-5.71a.817.817 0 0 0 .113-.396c0-.114 0-.227-.056-.283M1660 812.919c-4.24 0-7.463-2.996-8.877-4.918 1.753-2.432 4.976-4.92 8.877-4.92 4.24 0 7.463 2.997 8.876 4.92-1.81 2.43-4.975 4.918-8.876 4.918",
  fill: "#26890d",
  "data-name": "Path 280412"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1659.944 804.721a3.342 3.342 0 0 0-3.336 3.336 3.306 3.306 0 0 0 3.336 3.336 3.306 3.306 0 0 0 3.336-3.336 3.342 3.342 0 0 0-3.336-3.336m0 5.484a2.208 2.208 0 0 1-2.205-2.205c0-1.187.961-2.204 2.205-2.204 1.244 0 2.205.96 2.205 2.204-.057 1.188-1.018 2.205-2.205 2.205",
  fill: "#25890d",
  "data-name": "Path 280413"
}))));
export default SvgViewInvoice;